import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/img/icon/pentagon-check-green.svg'
import _imports_1 from '@/assets/img/icon/rectangular-enclamation-mark-red.svg'


const _hoisted_1 = { id: "courier-profile" }
const _hoisted_2 = { class: "flex items-center gap-2" }
const _hoisted_3 = {
  key: 0,
  src: _imports_0
}
const _hoisted_4 = {
  key: 1,
  src: _imports_1
}
const _hoisted_5 = {
  key: 2,
  class: "color-green font-bold text-base"
}
const _hoisted_6 = {
  key: 3,
  class: "color-red font-bold text-base"
}
const _hoisted_7 = { class: "flex w-full items-center" }
const _hoisted_8 = { class: "w-full" }
const _hoisted_9 = { class: "w-full flex justify-between mb-1 items-center" }
const _hoisted_10 = { class: "font-bold text-lg" }
const _hoisted_11 = /*#__PURE__*/_createVNode("p", { class: "color-red" }, "Edit Data Kurir", -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("i", { class: "pi pi-pencil color-red h-4 w-4" }, null, -1)
const _hoisted_13 = { class: "w-full flex justify-between items-center" }
const _hoisted_14 = { class: "flex" }
const _hoisted_15 = /*#__PURE__*/_createVNode("p", { class: "color-blue-grey" }, "Kurir - ", -1)
const _hoisted_16 = { class: "color-blue-grey" }
const _hoisted_17 = { class: "flex gap-2" }
const _hoisted_18 = /*#__PURE__*/_createVNode("div", { class: "flex" }, [
  /*#__PURE__*/_createVNode("p", { class: "font-bold text-xl" }, "Data Kurir")
], -1)
const _hoisted_19 = { class: "grid md:grid-cols-2 grid-cols-1 gap-6" }
const _hoisted_20 = /*#__PURE__*/_createVNode("p", { class: "color-blue-grey mb-1" }, "Tempat Tanggal Lahir", -1)
const _hoisted_21 = { class: "" }
const _hoisted_22 = /*#__PURE__*/_createVNode("p", { class: "color-blue-grey mb-1" }, "Jenjang Pendidikan", -1)
const _hoisted_23 = { class: "" }
const _hoisted_24 = /*#__PURE__*/_createVNode("p", { class: "color-blue-grey mb-1" }, "Jenis Kelamin", -1)
const _hoisted_25 = { class: "" }
const _hoisted_26 = /*#__PURE__*/_createVNode("p", { class: "color-blue-grey mb-1" }, "Status Pernikahan", -1)
const _hoisted_27 = { class: "" }
const _hoisted_28 = /*#__PURE__*/_createVNode("p", { class: "color-blue-grey mb-1" }, "Alamat Lengkap", -1)
const _hoisted_29 = {
  key: 0,
  class: ""
}
const _hoisted_30 = /*#__PURE__*/_createVNode("hr", {
  class: "my-5",
  style: {"height":"2px","background-color":"#CFD8DC"}
}, null, -1)
const _hoisted_31 = { class: "color-blue-grey mb-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Avatar = _resolveComponent("Avatar")
  const _component_InputSwitch = _resolveComponent("InputSwitch")
  const _component_Card = _resolveComponent("Card")
  const _component_Lightgallery = _resolveComponent("Lightgallery")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.data)
      ? (_openBlock(), _createBlock(_component_Card, {
          key: 0,
          class: "mb-5 p-1"
        }, {
          title: _withCtx(() => [
            _createVNode("div", _hoisted_2, [
              (_ctx.data.IsVerified)
                ? (_openBlock(), _createBlock("img", _hoisted_3))
                : (_openBlock(), _createBlock("img", _hoisted_4)),
              (_ctx.data.IsVerified)
                ? (_openBlock(), _createBlock("p", _hoisted_5, "Akun Terverifikasi"))
                : (_openBlock(), _createBlock("p", _hoisted_6, "Akun Belum Diverifikasi"))
            ])
          ]),
          content: _withCtx(() => [
            _createVNode("div", null, [
              _createVNode("div", _hoisted_7, [
                (_ctx.data.Picture)
                  ? (_openBlock(), _createBlock("img", {
                      key: 0,
                      class: "inline-block h-24 w-24 rounded-full mr-4",
                      src: `${_ctx.API_BASE}${_ctx.data.Picture}`
                    }, null, 8, ["src"]))
                  : (_openBlock(), _createBlock(_component_Avatar, {
                      key: 1,
                      label: _ctx.data?.Fullname?.charAt(0),
                      class: "mr-4",
                      size: "xlarge",
                      shape: "circle"
                    }, null, 8, ["label"])),
                _createVNode("div", _hoisted_8, [
                  _createVNode("div", _hoisted_9, [
                    _createVNode("p", _hoisted_10, _toDisplayString(_ctx.data.Fullname), 1),
                    _createVNode("div", {
                      class: "flex gap-2 items-center cursor-pointer",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toDetail()))
                    }, [
                      _hoisted_11,
                      _hoisted_12
                    ])
                  ]),
                  _createVNode("div", _hoisted_13, [
                    _createVNode("div", _hoisted_14, [
                      _hoisted_15,
                      _createVNode("p", _hoisted_16, _toDisplayString(_ctx.data.Agen), 1)
                    ]),
                    _createVNode("div", _hoisted_17, [
                      _createVNode(_component_InputSwitch, {
                        class: "switch-og",
                        disabled: true,
                        modelValue: _ctx.data.IsActive,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.data.IsActive = $event))
                      }, null, 8, ["modelValue"])
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_Card, { class: "mb-5 p-1" }, {
      title: _withCtx(() => [
        _hoisted_18
      ]),
      content: _withCtx(() => [
        _createVNode("div", null, [
          _createVNode("div", _hoisted_19, [
            _createVNode("div", null, [
              _hoisted_20,
              _createVNode("p", _hoisted_21, _toDisplayString(_ctx.data.BirthPlace) + ", " + _toDisplayString(_ctx.moment(_ctx.data.BirthDate).format('DD MMMM YYYY')), 1)
            ]),
            _createVNode("div", null, [
              _hoisted_22,
              _createVNode("p", _hoisted_23, _toDisplayString(_ctx.data.LastEducation), 1)
            ]),
            _createVNode("div", null, [
              _hoisted_24,
              _createVNode("p", _hoisted_25, _toDisplayString(_ctx.data.Gender === 'P' ? 'Wanita' : 'Laki - Laki'), 1)
            ]),
            _createVNode("div", null, [
              _hoisted_26,
              _createVNode("p", _hoisted_27, _toDisplayString(_ctx.data.StatusPernikahan), 1)
            ]),
            _createVNode("div", null, [
              _hoisted_28,
              (_ctx.data?.Addresses?.length > 0)
                ? (_openBlock(), _createBlock("p", _hoisted_29, _toDisplayString(_ctx.data.Addresses[0].Alamat1), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _hoisted_30,
          (_ctx.data?.Documents?.length > 0)
            ? (_openBlock(), _createBlock(_component_Lightgallery, {
                key: 0,
                images: _ctx.data?.Documents?.map((val) => ({
            ...val,
            src: _ctx.API_BASE + val.Path + `?Token=${_ctx.store.state.token.accessToken}`,
            alt: _ctx.labelDocument(val),
            file: _ctx.API_BASE + val.Path + `?Token=${_ctx.store.state.token.accessToken}`
          })),
                class: "grid md:grid-cols-3 grid-cols-1 gap-8"
              }, {
                content: _withCtx(({ image }) => [
                  _createVNode("p", _hoisted_31, _toDisplayString(image.alt), 1),
                  _createVNode("img", {
                    class: "rounded-lg cursor-pointer",
                    src: image.src,
                    alt: image.alt
                  }, null, 8, ["src", "alt"])
                ]),
                _: 1
              }, 8, ["images"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    })
  ]))
}